<div class="container">
  <button (click)="handleClick()">
    <i class="fa-solid fa-plus"></i>
    {{text}}
  </button>
</div>